import React, { useEffect, useState, Fragment, useRef } from "react";
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Box from '@material-ui/core/Box';
export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const contentRowNames = this.props.rowNames;
        const reportData = this.props.reportData;
        const totalAmount = this.props.totalAmount;

        return (
            <div>
                <h3 className="pr-2"><center><u>Daily Block Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.division === undefined ? "All Divisions" : searchData.division}</div>
                    <div className="col"><b>Field: </b> {searchData.field === undefined ? "All Fields" : searchData.field}</div>
                    <div className="col"><b>Block: </b> {searchData.block === undefined ? "All Blocks" : searchData.block}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>

                <div>
                    <Box display="flex" justifyContent="flex-end" p={2}>
                        <TableContainer component={Paper}>
                            <Table aria-label="simple table" border="1px solid black">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left" style={{ fontWeight: "bold" }}>
                                            Reg No.
                                        </TableCell>
                                        <TableCell align="left" style={{ fontWeight: "bold" }}>
                                            Name
                                        </TableCell>
                                        <TableCell align="left" style={{ fontWeight: "bold" }}>
                                            field
                                        </TableCell>
                                        <TableCell align="left" style={{ fontWeight: "bold" }}>
                                            block
                                        </TableCell>
                                        <TableCell align="left" style={{ fontWeight: "bold" }}>
                                            Session
                                        </TableCell>
                                        <TableCell align="left" style={{ fontWeight: "bold" }}>
                                            Image
                                        </TableCell>
                                        <TableCell align="right" style={{ fontWeight: "bold" }}>
                                            Quantity (Kg)
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {reportData.map((row) => (
                                        <TableRow key={row.employeeCode}>
                                            <TableCell component="th" scope="row">
                                                {row.regNumber}
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                {row.supplierName}
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                {row.fieldName}
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                {row.blockName}
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                {row.sessionName}
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                {row.image && (<img src={`data:employeeImage/jpeg;base64,${row.image}`} width="150" height="150"></img>)}
                                            </TableCell>
                                            <TableCell component="th" scope="row" align="right">
                                                {row.quantity}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                                <TableHead>
                                    <TableRow>
                                        <TableCell colSpan={6} align="center" style={{ fontWeight: "bold" }}>Total</TableCell>
                                        <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {totalAmount}</TableCell>
                                    </TableRow>
                                </TableHead>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>
            </div>
        );
    }
}